import Api from '@/services/Api'

const URL = 'cat/terminales-pos/';
const ACTION_ASIGNAR_CAJA = 'asignar_cajas/';
const ACTION_QUITAR_CAJA = 'quitar_caja/';
const ACTION_OBTENER_TIPOS_COBRO = 'obtener_tipos_cobro/';
const ACTION_OBTENER_TIPOS_POS = 'obtener_tipos_pos/';
const ACTION_OBTENER_AFILIACIONES_TIENDA ='obtener_afiliaciones_tienda/'
const ACTION_DESACTIVAR = 'desactivar/';

export default {
    
    fetch(params) {
        return Api().get(URL, {
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    update(id,params) {
        return Api().patch(`${URL}${id}/`, params)
    },
    save(params) {
        return Api().post(URL, params)
    },
    postAction(id, action, params) {
        return Api().post(`${URL}${id}/${action}/`, params);
    },
    asignarCajas(id,params) {
        return Api().post(`${URL}${id}/${ACTION_ASIGNAR_CAJA}`, params);
    },
    quitarCaja(id,params) {
        return Api().post(`${URL}${id}/${ACTION_QUITAR_CAJA}`, params);
    },
    obtenerTiposCobro(params={}){
        return Api().get(`${URL}${ACTION_OBTENER_TIPOS_COBRO}`, {
            params: params
        })
    },
    obtenerTiposPOS(params={}){
        return Api().get(`${URL}${ACTION_OBTENER_TIPOS_POS}`, {
            params: params
        })
    },
    obtenerAfiliacionesTienda(params={}){
        return Api().get(`${URL}${ACTION_OBTENER_AFILIACIONES_TIENDA}`, {
            params: params
        })
    },
    desactivar(id){
        return Api().post(`${URL}${id}/${ACTION_DESACTIVAR}`);
    }
}